import { ConditionModel } from '../misc/condition.model';
import { ResourceState, ResourceType } from '../../helpers/Const';
import {RuleModel} from "../misc/rule.model";

export class ResourceModel {
    name: string;
    uid: string;
    displayName: string;
    typeDisplayName: string;
    description: string;
    labels: { [key: string]: string };
    annotations: { [key: string]: string };
    conditions: ConditionModel[];
    state: ResourceState | null;
    moveFailed = false;
    moveInProcess = false;
    markedForDeletion = false;
    type: ResourceType;
    creationTime: string;
    modificationTime: string;
    path: string;
    apiVersion: string;
    resource: any;
    rules: RuleModel[];
    customSubresources: CustomSubresource[];
    children?: ResourceModel[];
    constructor(init?: Partial<ResourceModel>) {
        Object.assign(this, init);
    }
}

class CustomSubresource {
    name: string;
    jsonPath: string;
}
